import { fluid } from '@helpers/fluid';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  --sectionSpacing: ${fluid(48, 96)};

  margin: var(--sectionSpacing) 0;
  scroll-margin: calc(var(--scrollOffset) + var(--sectionSpacing)) 0 0;

  &[data-hide-overflow='true'] {
    overflow: hidden;
  }
`;
const Inner = styled.div `
  ${siteWide}
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
